export const base64UrlEncode = ({
  buffer,
}: {
  buffer: ArrayBuffer | Uint8Array | string;
}): string => {
  const bytes =
    typeof buffer === 'string'
      ? new TextEncoder().encode(buffer)
      : new Uint8Array(buffer as ArrayBuffer);
  return btoa(String.fromCharCode(...bytes))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
};

export const generateCodeVerifier = ({
  length = 64,
}: {
  length?: number;
} = {}): string => {
  const randomBytes = new Uint8Array(length);
  crypto.getRandomValues(randomBytes);
  return base64UrlEncode({ buffer: randomBytes });
};

export const generateCodeChallenge = async ({
  codeVerifier,
}: {
  codeVerifier: string;
}): Promise<string> => {
  const encoder = new TextEncoder();
  const data = encoder.encode(codeVerifier);
  const digest = await crypto.subtle.digest('SHA-256', data);
  return base64UrlEncode({ buffer: digest });
};
